export default "__VITE_ASSET__b816f06d__"